import { html } from '@resn/gozer-core';

import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import SectionMixin from 'component/sections/base/section-mixin';
import SectionFallbackMixin from 'component/sections/base/section-fallback-mixin';

// import Copy from '@resn/gozer-core/copy';
// import env from 'core/env';
// import Svg from 'component/svg';
// import { autobind } from 'core-decorators';
import { deviceBenchmark } from 'utils/device-benchmark';
// import { getRoute } from 'utils/get-pages';
// import { Router } from '@resn/gozer-core/router';
// import { inRange, map } from '@resn/gozer-math';

import Feature1 from './feature-1';
import Feature2 from './feature-2';
import Feature3 from './feature-3';

import './index.scss';

const template = ({ options }) => html` <section class="section  homeSoftware  inverseColors"></section> `;

@componentMixin(DomComponentMixin)
@componentMixin(deviceBenchmark.fallback ? SectionFallbackMixin : SectionMixin)
class homeSoftware extends Component {
    props = {};

    options = {
        template,
    };

    async onSetup() {
        this.feature1 = await new Feature1().setup({
            options: {
                appendTo: this.el,
            },
            props: {
                active: () => this.props.active,
            },
        });

        this.feature2 = await new Feature2().setup({
            options: {
                appendTo: this.el,
            },
            props: {
                active: () => this.props.active,
            },
        });

        this.feature3 = await new Feature3().setup({
            options: {
                appendTo: this.el,
            },
            props: {
                active: () => this.props.active,
            },
        });
    }

    update() {}

    calculateBounds(top) {
        this.feature1.calculateBounds(top);
    }
}

export default homeSoftware;
